export default __webpack_public_path__ + "static/media/pine-cones.347318b7.png";